import Vue from 'vue'
import Router from 'vue-router'

const home = () => import(/* webpackChunkName: "default" */ './views/Home.vue')
const view = () => import(/* webpackChunkName: "default" */ './layouts/View.vue')
const login = () => import(/* webpackChunkName: "default" */ './views/Auth/Login')
const logout = () => import(/* webpackChunkName: "default" */ './views/Auth/Logout')
const account = () => import(/* webpackChunkName: "default" */ './views/Auth/Account')
const http503 = () => import(/* webpackChunkName: "default" */ './views/Http503')
const http404 = () => import(/* webpackChunkName: "default" */ './views/Http404')

const fileList = () => import(/* webpackChunkName: "files" */ './views/Files/List.vue')
const fileCreate = () => import(/* webpackChunkName: "files" */ './views/Files/Create.vue')
const fileShow = () => import(/* webpackChunkName: "files" */ './views/Files/Show.vue')
const fileEdit = () => import(/* webpackChunkName: "files" */ './views/Files/Edit.vue')

const datasetList = () => import(/* webpackChunkName: "datasets" */ './views/Datasets/List.vue')
const datasetCreate = () => import(/* webpackChunkName: "datasets" */ './views/Datasets/Create.vue')
const datasetShow = () => import(/* webpackChunkName: "datasets" */ './views/Datasets/Show.vue')
const datasetEdit = () => import(/* webpackChunkName: "datasets" */ './views/Datasets/Edit.vue')

const predictionList = () => import(/* webpackChunkName: "predictions" */ './views/Predictions/List.vue')
const predictionCreate = () => import(/* webpackChunkName: "predictions" */ './views/Predictions/Create.vue')
const predictionShow = () => import(/* webpackChunkName: "predictions" */ './views/Predictions/Show.vue')
const predictionEdit = () => import(/* webpackChunkName: "predictions" */ './views/Predictions/Edit.vue')

const holdbackList = () => import(/* webpackChunkName: "holdbacks" */ './views/Holdbacks/List.vue')
const holdbackCreate = () => import(/* webpackChunkName: "holdbacks" */ './views/Holdbacks/Create.vue')
const holdbackShow = () => import(/* webpackChunkName: "holdbacks" */ './views/Holdbacks/Show.vue')
const holdbackEdit = () => import(/* webpackChunkName: "holdbacks" */ './views/Holdbacks/Edit.vue')

const exportList = () => import(/* webpackChunkName: "exports" */ './views/Exports/List.vue')
const exportCreate = () => import(/* webpackChunkName: "exports" */ './views/Exports/Create.vue')
const exportShow = () => import(/* webpackChunkName: "exports" */ './views/Exports/Show.vue')
const exportEdit = () => import(/* webpackChunkName: "exports" */ './views/Exports/Edit.vue')

const reportList = () => import(/* webpackChunkName: "reports" */ './views/Reports/List.vue')
const reportCreate = () => import(/* webpackChunkName: "reports" */ './views/Reports/Create.vue')
const reportShow = () => import(/* webpackChunkName: "reports" */ './views/Reports/Show.vue')
const reportEdit = () => import(/* webpackChunkName: "reports" */ './views/Reports/Edit.vue')

const appList = () => import(/* webpackChunkName: "applications" */ './views/Apps/List.vue')
const appShow = () => import(/* webpackChunkName: "applications" */ './views/Apps/Show.vue')

const agentList = () => import(/* webpackChunkName: "applications" */ './views/Agents/List.vue')
const agentShow = () => import(/* webpackChunkName: "applications" */ './views/Agents/Show.vue')

const helpAbout = () => import(/* webpackChunkName: "help" */ './views/Help/About')
const helpCredits = () => import(/* webpackChunkName: "help" */ './views/Help/Credits')
const helpReleaseNotes = () => import(/* webpackChunkName: "help" */ './views/Help/ReleaseNotes')
const helpHome = () => import(/* webpackChunkName: "help" */ './views/Help/Home')
const helpFiles = () => import(/* webpackChunkName: "help" */ './views/Help/Files')
const helpDatasets = () => import(/* webpackChunkName: "help" */ './views/Help/Datasets')
const helpPredictions = () => import(/* webpackChunkName: "help" */ './views/Help/Predictions')
const helpApplications = () => import(/* webpackChunkName: "help" */ './views/Help/Applications')
const helpForecasting = () => import(/* webpackChunkName: "help" */ './views/Help/Forecasting')
const helpVirtualWell = () => import(/* webpackChunkName: "help" */ './views/Help/VirtualWell')
const helpDucsPermits = () => import(/* webpackChunkName: "help" */ './views/Help/DucsPermits')
const helpHoldback = () => import(/* webpackChunkName: "help" */ './views/Help/Holdback')


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'home', component: home, meta: { mode: 'home', title: 'Dashboard' } },
    {
      path: '/files', component: view, children: [
        { path: '', name: 'fileList', component: fileList, meta: { mode: 'file', title: 'Files' } },
        { path: 'create', name: 'fileCreate', component: fileCreate, meta: { mode: 'file', title: 'Files' } },
        { path: ':uuid', name: 'fileShow', component: fileShow, meta: { mode: 'file', title: 'Files' } },
        { path: ':uuid/edit', name: 'fileEdit', component: fileEdit, meta: { mode: 'file', title: 'Files' } },
      ]
    },
    {
      path: '/datasets', component: view, children: [
        { path: '', name: 'datasetList', component: datasetList, meta: { mode: 'dataset', title: 'Datasets' } },
        { path: 'create', name: 'datasetCreate', component: datasetCreate, meta: { mode: 'dataset', title: 'Datasets' } },
        { path: ':uuid', name: 'datasetShow', component: datasetShow, meta: { mode: 'dataset', title: 'Datasets' } },
        { path: ':uuid/edit', name: 'datasetEdit', component: datasetEdit, meta: { mode: 'dataset', title: 'Datasets' } },
      ]
    },
    {
      path: '/predictions', component: view, children: [
        { path: '', name: 'predictionList', component: predictionList, meta: { mode: 'prediction', title: 'Predictions' } },
        { path: 'create', name: 'predictionCreate', component: predictionCreate, meta: { mode: 'prediction', title: 'Predictions' } },
        { path: ':uuid', name: 'predictionShow', component: predictionShow, meta: { mode: 'prediction', title: 'Predictions' } },
        { path: ':uuid/edit', name: 'predictionEdit', component: predictionEdit, meta: { mode: 'prediction', title: 'Predictions' } },
      ]
    },
    {
      path: '/holdbacks', component: view, children: [
        { path: '', name: 'holdbackList', component: holdbackList, meta: { mode: 'holdback', title: 'Holdbacks' } },
        { path: 'create', name: 'holdbackCreate', component: holdbackCreate, meta: { mode: 'holdback', title: 'Holdbacks' } },
        { path: ':uuid', name: 'holdbackShow', component: holdbackShow, meta: { mode: 'holdback', title: 'Holdbacks' } },
        { path: ':uuid/edit', name: 'holdbackEdit', component: holdbackEdit, meta: { mode: 'holdback', title: 'Holdbacks' } },
      ]
    },
    {
      path: '/exports', component: view, children: [
        { path: '', name: 'exportList', component: exportList, meta: { mode: 'export', title: 'Exports' } },
        { path: 'create', name: 'exportCreate', component: exportCreate, meta: { mode: 'export', title: 'Exports' } },
        { path: ':uuid', name: 'exportShow', component: exportShow, meta: { mode: 'export', title: 'Exports' } },
        { path: ':uuid/edit', name: 'exportEdit', component: exportEdit, meta: { mode: 'export', title: 'Exports' } },
      ]
    },
    {
      path: '/reports', component: view, children: [
        { path: '', name: 'reportList', component: reportList, meta: { mode: 'report', title: 'Reports' } },
        { path: 'create', name: 'reportCreate', component: reportCreate, meta: { mode: 'report', title: 'Reports' } },
        { path: ':uuid', name: 'reportShow', component: reportShow, meta: { mode: 'report', title: 'Reports' } },
        { path: ':uuid/edit', name: 'reportEdit', component: reportEdit, meta: { mode: 'report', title: 'Reports' } },
      ]
    },
    {
      path: '/applications', component: view, children: [
        { path: '', name: 'applicationList', component: appList, meta: { mode: 'application', title: 'Applications' } },
        { path: ':slug', name: 'applicationShow', component: appShow, meta: { mode: 'application', title: 'Applications' } },
      ],
    },
    {
      path: '/agents', component: view, children: [
        { path: '', name: 'agentList', component: agentList, meta: { mode: 'agent', title: 'Agents' } },
        { path: ':slug', name: 'agentShow', component: agentShow, meta: { mode: 'agent', title: 'Agents' } },
      ],
    },
    { path: '/login', meta: { layout: "blank" }, name: 'login', component: login, meta: { title: 'Login', layout: 'blank' } },
    { path: '/logout', meta: { layout: "blank" }, name: 'logout', component: logout, meta: { title: 'Logout', layout: 'blank' } },
    { path: '/account', name: 'account', component: account, meta: { title: 'Account' } },
    {
      path: '/help', component: view, children: [
        { path: '', name: 'help', component: helpHome, meta: { title: 'Help' } },
        { path: 'about', component: helpAbout, meta: { title: 'About' } },
        { path: 'credits', component: helpCredits, meta: { title: 'Credits' } },
        { path: 'release_notes', component: helpReleaseNotes, meta: { title: 'Release Notes' } },
        { path: 'files', component: helpFiles, meta: { title: 'Files' } },
        { path: 'datasets', component: helpDatasets, meta: { title: 'Datasets' } },
        { path: 'predictions', component: helpPredictions, meta: { title: 'Predictions' } },
        { path: 'applications', component: helpApplications, meta: { title: 'Applications' } },
        { path: 'applications/forecasting', component: helpForecasting, meta: { title: 'Production Forecasting' } },
        { path: 'applications/holdback', component: helpHoldback, meta: { title: 'Holdback Analysis' } },
        { path: 'applications/predict', component: helpDucsPermits, meta: { title: 'Ducs and Permits' } },
        { path: 'applications/virtualwell', component: helpVirtualWell, meta: { title: 'Virtual Well' } },
      ]
    },
    { path: '/error', name: 'http503', component: http503, meta: { title: 'Service Unavailable', layout: 'blank' } },
    { path: '*', name: 'http404', component: http404, meta: { title: 'Not Found' } },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } 
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth', offset: { x: 0, y: 64 } }
    }
    return { x: 0, y: 0 }
  },
})

// Suppress NavigationDuplicated errors
const originalPush = router.push
const originalReplace = router.replace

router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

router.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default router
